<template>
  <el-dialog
    class="rc-dialog"
    :title="edit ? '编辑版块' : '新增版块'"
    :visible.sync="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
    width="520px"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="名称类型：" prop="blockNameType">
            <el-radio-group
              v-model="curdForm.blockNameType"
              @change="onBlockNameChange"
            >
              <el-radio :label="0">文字</el-radio>
              <el-radio :label="1">图片</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <template v-if="curdForm.blockNameType == 0">
          <el-col>
            <el-form-item label="版块名称：" prop="blockName">
              <el-input
                v-model="curdForm.blockName"
                placeholder="请填写版块名称"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="对齐方式：" prop="alignType">
              <el-radio-group v-model="curdForm.alignType">
                <el-radio size="medium" :label="0">居左</el-radio>
                <el-radio size="medium" :label="1">居中</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="下划线：" prop="hasUnderline">
              <el-radio-group v-model="curdForm.hasUnderline">
                <el-radio size="medium" :label="0">有</el-radio>
                <el-radio size="medium" :label="1">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="curdForm.hasUnderline == 0">
            <el-form-item label="色值：" prop="colorValue">
              <el-color-picker v-model="curdForm.colorValue"></el-color-picker>
              <!-- <el-input
                v-model="curdForm.colorValue"
                placeholder="请输入下划线16进制颜色值"
              /> -->
            </el-form-item>
          </el-col>
        </template>
        <template v-else>
          <el-col>
            <el-form-item label="名称图片：" prop="fileUrl">
              <av-preview
                v-if="curdForm.fileUrl"
                :src="curdForm.fileUrl"
                type="image"
                @delete="deleteCover"
              />
              <upload
                v-else
                :draggable="false"
                :path="'subject/img'"
                type="image"
                v-model="curdForm.fileUrls"
              />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="对齐方式：" prop="alignType">
              <el-radio-group v-model="curdForm.alignType">
                <el-radio size="medium" :label="0">居左</el-radio>
                <el-radio size="medium" :label="1">居中</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </template>
        <el-col>
          <el-form-item label="版块类型：" prop="blockType">
            <el-radio-group v-model="curdForm.blockType" :disabled="edit">
              <el-radio
                :label="parseInt(item.paramKey)"
                v-for="(item, i) in blockTypeList"
                :key="i + item.paramValue"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col>
            <el-form-item label="资源展示：" prop="showType">
              <el-radio-group v-model="curdForm.showType">
                <el-radio size="medium" :label="2">默认收起</el-radio>
                <el-radio size="medium" :label="1">默认展开</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        <el-col>
          <el-form-item label="版块状态：" prop="onlineStatus">
            <el-radio-group v-model="curdForm.onlineStatus">
              <el-radio
                :label="parseInt(item.paramKey)"
                v-for="(item, i) in onlineStatusList"
                :key="i + item.paramValue"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" btntype title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import vue from "@/main.js";
import rulesFactory from "@/utils/rules";
import { getSysParamByTypes } from "@/api/sysParam";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";
export default {
  components: { butn, Upload, AvPreview },
  data() {
    return {
      rules: {
        blockNameType: [rulesFactory.required("请选择板块类型")],
        blockName: [
          rulesFactory.required("请输入版块名称"),
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        alignType: [rulesFactory.required("请选择对齐方式")],
        hasUnderline: [rulesFactory.required("请选择是否有下划线")],
        colorValue: [
          rulesFactory.required("请选择颜色值"),
          rulesFactory.size("最多输入10个字", 0, 10),
        ],
        blockType: [rulesFactory.required("请选择版块类型")],
        showType: [rulesFactory.required("请选择资源展示方式")],
        onlineStatus: [rulesFactory.required("请选择版块状态")],
        fileUrl: [rulesFactory.required("请上传名称图片")],
      },
      edit: false,
      CUFlag: false,
      curdForm: {
        blockNameType: 0,
        blockName: "",
        blockType: 0,
        alignType: 0,
        hasUnderline: 0,
        showType: 2,
        onlineStatus: 1,
        fileUrls: [],
        fileUrl: "",
        colorValue: "",
        id: "",
        uuid: "",
      },
      blockTypeList: [],
      onlineStatusList: [],
    };
  },
  watch: {
    "curdForm.fileUrls": {
      handler(val) {
        if (val && val.length > 0) {
          this.curdForm.fileUrl = val[0].url;
        } else {
          this.curdForm.fileUrl = "";
        }
      },
    },
  },
  created() {
    this.getSysParamByTypes(["SUBJECT_BLOCK_TYPE", "ONLINE_STATUS"]);

    vue.$on("handleSubjectBlock", this.onBlockOpen);
  },
  beforeDestroy() {
    vue.$off("handleSubjectBlock", this.onBlockOpen);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        //数据字典-专题版块类型获取
        this.blockTypeList = res.data["SUBJECT_BLOCK_TYPE"] || [];
        //数据字典-专题版块状态获取
        this.onlineStatusList = res.data["ONLINE_STATUS"] || [];
      });
    },
    onBlockOpen(item) {
      this.edit = !!item;
      this.CUFlag = true;
      if (item) {
        if (item.blockNameType == 1) {
          this.curdForm = {
            ...item,
            blockNameType: item.blockNameType,
            blockType: item.blockType,
            alignType: item.alignType,
            onlineStatus: item.onlineStatus,
            fileUrls: [{ url: item.blockName }],
            fileUrl: item.blockName,
            showType: item.showType,
            blockName: "",
            hasUnderline: 0,
            colorValue: "",
            // id: item.id,
            // uuid: item.uuid
          };
        } else {
          this.curdForm = {
            ...item,
            blockNameType: item.blockNameType,
            blockType: item.blockType,
            alignType: item.alignType,
            onlineStatus: item.onlineStatus,
            blockName: item.blockName,
            hasUnderline: item.hasUnderline,
            colorValue: item.colorValue,
            showType: item.showType,
            fileUrls: [],
            fileUrl: "",
            id: item.id,
            uuid: item.uuid
          };
        }
      } else {
        this.curdForm = {
          blockNameType: 0,
          blockName: "",
          blockType: 0,
          alignType: 0,
          hasUnderline: 0,
          showType: 2,
          onlineStatus: 1,
          fileUrls: [],
          fileUrl: "",
          colorValue: "",
        };
      }
      this.$nextTick(() => {
        this.$refs.curdForm.clearValidate();
      });
    },
    findValueByKey(array, searchKey) {
      if (Array.isArray(array)) {
        for (const obj of array) {
          if (obj.paramKey === searchKey) {
            return obj.paramValue;
          }
        }
      }
      return "";
    },
    createData() {
      this.$refs.curdForm.validate((valid) => {
        if (valid) {
          let subjectBlock = Object.assign({}, this.curdForm);
          delete subjectBlock.fileUrls;
          subjectBlock.blockTypeName = this.findValueByKey(
            this.blockTypeList,
            subjectBlock.blockType.toString()
          );
          subjectBlock.onlineStatusName = this.findValueByKey(
            this.onlineStatusList,
            subjectBlock.onlineStatus.toString()
          );
          if (subjectBlock.blockNameType == 1) {
            subjectBlock.blockName = subjectBlock.fileUrl;
            delete subjectBlock.hasUnderline;
            delete subjectBlock.colorValue;
          }
          delete subjectBlock.fileUrl;
          subjectBlock = JSON.stringify(subjectBlock);
          if (this.edit) {
            vue.$emit("editSubjectBlock", subjectBlock);
          } else {
            vue.$emit("addSubjectBlock", subjectBlock);
          }
          this.closeDialog();
        }
      });
    },
    onBlockNameChange() {
      this.$refs.curdForm.clearValidate();
    },
    closeDialog() {
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
      this.CUFlag = false;
    },
    deleteCover() {
      this.curdForm.fileUrls = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.el-radio:last-child {
  margin-right: 30px !important;
}
.flex-column {
  flex-direction: column;
  justify-content: center;
}
</style>
